import { atom } from "recoil";

import { MetricField } from "../../gql-generated/types";

export const topLensesAtom = atom({
    key: "topLensesAtom",
    default: MetricField.LensPlays,
});
